import React, { useState, useEffect } from "react";
import logo from "../../assets/images/pass-logo.png";
import {
  NavDropdown,
  Nav,
} from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import { NavLink } from "react-router-dom";
import NavbarBrand from "react-bootstrap/esm/NavbarBrand";
import NavbarToggle from "react-bootstrap/esm/NavbarToggle";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import Container from "react-bootstrap/esm/Container";
import "../../css/navbar.css";

const NavBar = () => {
  return (
    <div className="">
      <Navbar
        collapseOnSelect
        className="nav-bar-header"
        expand="lg"
      >
        <Container>
          <Navbar.Brand>
            <img src={logo} alt="logo" className="logo" />
            <span className="company-name">
              <span className="c-name1">PA</span>
              <span className="c-name2">S</span>
              <span className="c-name3">S</span>
            </span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto ">
              <div className="nav-menu">
                <Nav.Link href="/" className="nav-link">
                  Home
                </Nav.Link>

                <Nav.Link href="platforms" className="nav-link">
                  Platforms
                </Nav.Link>
                <NavDropdown title="Vendors" id="basic-nav-dropdown">
                  <div className="nav-bar-sub">
                    <NavDropdown.Item
                      href="/vendors/sellers"
                      className="nav-sub-link"
                    >
                      Sellers
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="/vendors/services"
                      className="nav-sub-link"
                    >
                      Services
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="/vendors/properties"
                      className="nav-sub-link"
                    >
                      Properties
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item
                      href="/vendor-signin"
                      className="nav-sub-link"
                    >
                      Account
                    </NavDropdown.Item>
                  </div>
                </NavDropdown>
                <Nav.Link href="/about" className="nav-link">
                  About
                </Nav.Link>
              </div>
              <div className="">
                <Nav.Link href="/signin">
                  <button className="post-primary-btn">Login</button>
                </Nav.Link>
              </div>
              <div className="">
                <Nav.Link href="/signup">
                  <button className="post-secondary-btn">Get Started</button>
                </Nav.Link>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavBar;
